import React, { Suspense } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
} from "react-router-dom";
import { getLoggedInUser } from "../utilities/helper";

import {
  PrivateSigninRoute,
  PrivateRoute,
  roleBasedNavigation,
} from "./PrivateRoutes";

const App = React.lazy(() => import("../app/App"));
const CreateNewPassword = React.lazy(() => import("../features/createNewPassword/createNewPassword"));
const ForgotPassword = React.lazy(() => import("../features/forgotPassword/forgotPassword"));
const Login = React.lazy(() => import("../features/login/login"));
const IndianSignupPAN = React.lazy(() => import("../features/signup/components/pan/IndianSignupPAN"));
const SignUp = React.lazy(() => import("../features/signup/signup"));
const QualityCheck = React.lazy(() => import("../features/qualityCheck/qualityCheck"));
const AdminArns = React.lazy(() => import("../features/adminArns/adminArns"));

export default function Router() {
  const { user } = getLoggedInUser();
  let goTo = user ? roleBasedNavigation(user?.roles[0] || "") : "login";
  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Navigate replace to={goTo} />} />
        <Route
          path="/login"
          exact
          element={
            <PrivateSigninRoute>
              <Login />
            </PrivateSigninRoute>
          }
        />
        <Route
          path="/arns"
          exact
          element={
            <PrivateSigninRoute>
              <AdminArns />
            </PrivateSigninRoute>
          }
        />
        <Route
          path="/signup"
          element={
            <PrivateSigninRoute>
              <SignUp />
            </PrivateSigninRoute>
          }
        />
        <Route
          path="signup/pan"
          element={
            <PrivateSigninRoute>
              <IndianSignupPAN />
            </PrivateSigninRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PrivateSigninRoute>
              <ForgotPassword />
            </PrivateSigninRoute>
          }
        />
        <Route
          path="/create-new"
          element={
            <PrivateSigninRoute>
              <CreateNewPassword />
            </PrivateSigninRoute>
          }
        />
        <Route
          path="/inspection"
          exact
          element={
            <PrivateSigninRoute>
              <QualityCheck />
            </PrivateSigninRoute>
          }
        />
        <Route
          path="/app/*"
          element={
            <PrivateRoute>
              <App />
            </PrivateRoute>
          }
        />
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
